import onReady from 'document-ready';

onReady(() => {
    let unobserveBusyFlag = app.store.observe(
        state => [!!state.ui.pendingTasks, !!state.ui.sidePanel.externalURL, !!state.ui.raiseSidePanel].join(),
        _.debounce(
            () => {
                let state = app.store.getState(),
                    isBusy = !!state.ui.pendingTasks,
                    hasExternalContentActive = !!state.ui.sidePanel.externalURL;

                if (isBusy) {
                    document.body.classList.add('busy');
                } else {
                    document.body.classList.remove('busy');
                }

                if (hasExternalContentActive) {
                    document.body.classList.add('external-content');
                } else {
                    document.body.classList.remove('external-content');
                }
            },
            200,
            {
                leading: true,
                trailing: true,
            }
        )
    );

    app.onShutdown(unobserveBusyFlag);
});
